var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-btn",class:{ 'vertical-space': _vm.verticalSpace },on:{"click":_vm.clickHandler}},[_c('img',{attrs:{"src":require("../../assets/left-arrow.svg"),"alt":"left-arrow","width":"20"}}),_c('span',[_vm._v(_vm._s(_vm.$t("utility.back")))])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }